module.exports = __webpack_public_path__ + "static/media/trash.52bc1a3b.png";